import {
  fetchGetApiAnnouncements,
  GetApiAnnouncementsResponse,
} from '@iwoca/lapi-client/announcements';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import { isAnnouncementsEnabled } from './announcementsEnabled';

export function useAnnouncementsQuery() {
  const { pathname } = useLocation();
  const enabled = isAnnouncementsEnabled();

  return useQuery<GetApiAnnouncementsResponse>({
    queryKey: ['announcements', pathname],
    queryFn: () =>
      fetchGetApiAnnouncements({
        query: { frontend: 'signup', path: pathname },
      }),
    enabled,
    staleTime: 60_000,
  });
}
